import { GET_ACTIVE_EMPLOYEES } from "./types"
import axios from "../auth/axiosAuth"
import { appAdminBackendURL } from "../config"

export const getActiveEmployees = () => async (dispatch) => {
    const res = await axios.get(`${appAdminBackendURL}/employee/active`)
    dispatch({ type: GET_ACTIVE_EMPLOYEES, payload: res.data })
}
